export const ULTRA_LATERAL_INSTRUCTOR_ID = "1";
export const ULTRA_BLACKOUT_BATCH_CONCURRENCY = 6;
export const ULTRA_BLACKOUT_REVALIDATE_AFTER_MS = 12 * 1000;
/** Delay before refetching blackouts after optimistic Ctrl+Q / popup paint. */
export const OPTIMISTIC_BLACKOUT_REVALIDATE_DELAY_MS = 4000;
export const ULTRA_LESSON_MINUTES = 90;
